import React,{useLayoutEffect, useRef, useState} from 'react';
import { useTable } from '../../context/TableContext.js';
import EditableCell from './EditableCell.js';

export default function EditableTable() {
  const { state } = useTable();

  const getSize = () => {
    switch (state.tableSize) {
      case 'three-quarters':  return { w: '75%', h: '75%' };
      case 'half':            return { w: '50%', h: '50%' };
      case 'quarter':         return { w: '25%', h: '25%' };
      case 'full':            
      default:                return { w: '100%', h: '100%' };
    }
  };

  const { w, h } = getSize();

  const renderRows = () => {
    const headerRows = [];
    const bodyRows = [];
    const footerRows = [];

    for (let row = 0; row < state.rows; row++) {
      const isHeader = state.headerRows.includes(row);
      const isFooter = state.footerRows.includes(row);
      const isFirst  = row === 0;

      const rowElement = (
        <tr
  key={row}
  className={`${isHeader ? 'header-row' : ''} ${isFooter ? 'footer-row' : ''}`}
  style={{ height: isFirst ? '0px' : `1` }}
  data-zero={isFirst ? 'true' : 'false'}
>
  {isFirst
    ? Array.from({ length: state.columns }, (_, col) => (
        <td
          key={`zero-${row}-${col}`}
          style={{
            height: 0,
            padding: 0,
            // no vertical borders so the row contributes no height
            borderTop: 'none',
            borderBottom: 'none',
            // optional: also remove horizontal borders for a fully invisible row
            borderLeft: 'none',
            borderRight: 'none',
            boxSizing: 'border-box',
          }}
        />
      ))
    : Array.from({ length: state.columns }, (_, col) => {
        const cellId = `${row}-${col}`;
        const cell = state.cells[cellId];
        if (!cell || cell.merged) return null;

        return (
          <EditableCell
            key={cellId}
            cell={cell}
            isHeader={isHeader}
            isFooter={isFooter}
            isFirst={isFirst}
            width={state.columns}
            height={state.rows}
            last={state.columns-1===col}
          />
        );
      })}
</tr>

      );

      if (isHeader)      headerRows.push(rowElement);
      else if (isFooter) footerRows.push(rowElement);
      else               bodyRows.push(rowElement);
    }

    return { headerRows, bodyRows, footerRows };
  };

  const { headerRows, bodyRows, footerRows } = renderRows();

  return (
    <div className={`w-full h-full w-[100%] h-[100%]`}>
      <table
        className={`table-fixed`}
        // use separate borders so per-side toggles are WYSIWYG
        style={{
            width: w,
            height: h,
            tableLayout: 'fixed',
            borderCollapse: 'separate',
            borderSpacing: 0,
          }}
        data-testid="editable-table"
      >
        {headerRows.length > 0 && <thead>{headerRows}</thead>}
        <tbody>{bodyRows}</tbody>
        {footerRows.length > 0 && <tfoot>{footerRows}</tfoot>}
      </table>
    </div>
  );
}

